import React from "react";
import { Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import UploadFileIcon from "../../Assets/Images/Apps/CertificateValidator/upload-icon.svg";

export type FileDropzoneContentProps = {
    title: string;
    description: string;
    icon?: string;
    iconAlt?: string;
};

const FileDropzoneContent: React.FC<FileDropzoneContentProps> = ({ title, description, icon, iconAlt }) => {
    const { t } = useTranslation();

    const defaultIcon = icon || UploadFileIcon;
    const defaultIconAlt = iconAlt || t("certificate_validator.upload_file.upload_icon_alt", "Upload file icon");

    return (
        <>
            <Typography variant="body1" className="as-body-text" style={{ fontWeight: 600 }} component="h3">
                {title}
            </Typography>
            <Typography variant="body2" id="file-upload-instructions">
                {description}
            </Typography>
            <img src={defaultIcon} alt={defaultIconAlt} role="presentation" style={{ marginTop: "10px" }} />
        </>
    );
};

export default FileDropzoneContent;
